import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWifiWeak: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconWifiWeak"><Path d="M16.7881 13.9058C13.9972 11.7293 10.0024 11.7293 7.21152 13.9058L6.28906 12.723C9.6222 10.1236 14.3774 10.1236 17.7105 12.723L16.7881 13.9058Z" fill="currentColor"/><Path d="M11.9993 20C12.5516 20 12.9993 19.5523 12.9993 19C12.9993 18.4477 12.5516 18 11.9993 18C11.447 18 10.9993 18.4477 10.9993 19C10.9993 19.5523 11.447 20 11.9993 20Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWifiWeak;
